import { IconographyTypes } from '@genial/icons';
import { CoeOfferEntity } from '@genial/services';

export type Offer = CoeOfferEntity;

export type StructuredOperationDetailsProps = { item: Offer };

export interface StructuredOperationsTableProps {
  OffersAll?: Offer[];
  OffersSearchTerm?: Offer[];
  onOpenDetailsModal: (data: StructuredOperationDetailsProps) => void;
  isLoading: boolean;
  isLoadingMore: boolean;
  handleEndReached: () => void;
  marketIsClosed: boolean;
  marketStatus?: string;
  invalidColumns?: boolean;
  handleClearSearch?: () => void;
  hasEmpty: boolean;
}

export type FormData = { createAppliedAmount: string };

interface VariationStyle {
  name: IconographyTypes.Option;
  color: string;
}

export type VariationStyleValueProp = 1 | 2 | 3 | 'error';

export const getVariationStyle = (value: VariationStyleValueProp): Partial<VariationStyle> => {
  const style = {
    1: {
      color: 'feedback.success.default',
      name: 'ArrowUp' as IconographyTypes.Option,
    },
    2: {
      color: 'feedback.error.default',
      name: 'ArrowDown' as IconographyTypes.Option,
    },
    3: {
      color: 'brand.primary.principal',
      name: 'ArrowRight' as IconographyTypes.Option,
    },
    error: {},
  };

  return style[value || 'error'];
};
